import {useSelector} from 'react-redux';

import {useGetCustomerData} from 'hooks/getCustomerData/getCustomerData';

import {getCustomerAddresses} from '../../store/selectors/deliveryStep/deliveryStep';

/**
 * Get is user with address
 *
 * @return {boolean} user with address
 */
export const useGetIsUserWithAddress = () => {
    const customer = useGetCustomerData();
    const customerAddresses = useSelector(getCustomerAddresses);
    const isUserHasAddresses =
        customerAddresses.billing_address_id && customerAddresses.shipping_address_id;
    return Boolean(customer.is_logged_in && isUserHasAddresses);
};
